import React from "react";
import { Wrapper } from "../wrapper";
import { Form } from "@components";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { getFormGsapAccessTypes } from "@api";
import { Grid } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { Table } from "../../../../../../components/table";

export type GSAPFormValues = {
  requestor: string;
  requestorTitle: string;
  requestorTelephoneNumber: string;
  dateRequested: Date | null;
  setup1: boolean;
  setup2: boolean;
  setup3: boolean;
  setup4: boolean;
  employeeNumber: string;
  lengthOfContract: string;
  userName: string;
  userDepartment: string;
  accessPurpose: string;
  emailAddress: string;
  telephoneNumber: string;
  accessEffectiveDate: Date | null;
  accessEndDate: Date | null;
  userADID: string;
  envCertUS: boolean;
  envCertAP: boolean;
  envCertEU: boolean;
  envCertVesper: boolean;
  envProdUS: boolean;
  envProdAP: boolean;
  envProdEU: boolean;
  envProdVesper: boolean;
  accessType1: boolean;
  accessType2: boolean;
  accessType3: boolean;
  accessType4: boolean;
  cardMask: string;
  maxRecord: string;
  contactHeirarchy: string;
  ap1: boolean;
  ap2: boolean;
  cad1: boolean;
  cad2: boolean;
  cad3: boolean;
  us1: boolean;
  us2: boolean;
  us3: boolean;
  us4: boolean;
  latinAmerica: boolean;
  euacquiring: boolean;
  eudirect: boolean;
  securityRoles: {
    accessType: string;
    securityRole: string;
    isAdd: boolean;
    isRemove: boolean;
    isUS: boolean;
    isAP: boolean;
    isEU: boolean;
    isVesper: boolean;    
  }[];
};

type Key = keyof GSAPFormValues;

type SecurityRoleKeys = keyof GSAPFormValues["securityRoles"][0];

type Props = {
  onCancel: () => void;
  onSubmit: (values: GSAPFormValues) => void;
  open: boolean;
  values: Partial<GSAPFormValues>;
  readonly?: boolean;
};

export const GSAPForm: React.FC<Props> = ({
  onCancel,
  onSubmit,
  open,
  values,
  readonly,
}) => {
  const form = Form.useManager<GSAPFormValues>({
    requestor: values?.requestor ? values.requestor : "",
    requestorTitle: values?.requestorTitle ? values.requestorTitle : "",
    requestorTelephoneNumber: values?.requestorTelephoneNumber ? values.requestorTelephoneNumber : "",
    dateRequested: values?.dateRequested ? values.dateRequested : null,
    setup1: values?.setup1 ? values.setup1 : false,
    setup2: values?.setup2 ? values.setup2 : false,
    setup3: values?.setup3 ? values.setup3 : false,
    setup4: values?.setup4 ? values.setup4 : false,
    employeeNumber: values?.employeeNumber ? values.employeeNumber : "",
    lengthOfContract: values?.lengthOfContract ? values.lengthOfContract : "",
    userName: values?.userName ? values.userName : "",
    userDepartment: values?.userDepartment ? values.userDepartment : "",
    accessPurpose: values?.accessPurpose ? values.accessPurpose : "",
    emailAddress: values?.emailAddress ? values.emailAddress : "",
    telephoneNumber: values?.telephoneNumber ? values.telephoneNumber : "",
    accessEffectiveDate: values?.accessEffectiveDate ? values.accessEffectiveDate : null,
    accessEndDate: values?.accessEndDate ? values.accessEndDate : null,
    userADID: values?.userADID ? values.userADID : "",
    envCertUS: values?.envCertUS ? values.envCertUS : false,
    envCertAP: values?.envCertAP ? values.envCertAP : false,
    envCertEU: values?.envCertEU ? values.envCertEU : false,
    envCertVesper: values?.envCertVesper ? values.envCertVesper : false,
    envProdUS: values?.envProdUS ? values.envProdUS : false,
    envProdAP: values?.envProdAP ? values.envProdAP : false,
    envProdEU: values?.envProdEU ? values.envProdEU : false,
    envProdVesper: values?.envProdVesper ? values.envProdVesper : false,
    accessType1: values?.accessType1 ? values.accessType1 : false,
    accessType2: values?.accessType2 ? values.accessType2 : false,
    accessType3: values?.accessType3 ? values.accessType3 : false,
    accessType4: values?.accessType4 ? values.accessType4 : false,
    cardMask: values?.cardMask ? values.cardMask : "",
    maxRecord: values?.maxRecord ? values.maxRecord : "",
    contactHeirarchy: values?.contactHeirarchy ? values.contactHeirarchy : "",
    ap1: values?.ap1 ? values.ap1 : false,
    ap2: values?.ap2 ? values.ap2 : false,
    cad1: values?.cad1 ? values.cad1 : false,
    cad2: values?.cad2 ? values.cad2 : false,
    cad3: values?.cad3 ? values.cad3 : false,
    us1: values?.us1 ? values.us1 : false,
    us2: values?.us2 ? values.us2 : false,
    us3: values?.us3 ? values.us3 : false,
    us4: values?.us4 ? values.us4 : false,
    latinAmerica: values?.latinAmerica ? values.latinAmerica : false,
    euacquiring: values?.euacquiring ? values.euacquiring : false,
    eudirect: values?.eudirect ? values.eudirect : false,
    securityRoles: values?.securityRoles ? values.securityRoles : [],
  });

  console.log(values);
  
  const securityRoleForm = Form.useManager<GSAPFormValues["securityRoles"][0]>({
    accessType: "",
    securityRole: "",
    isAdd: false,
    isRemove: false,
    isUS: false,
    isAP: false,
    isEU: false,
    isVesper: false,
  });
  const [fetching, setFetching] = React.useState(false);
  const [data, setData] = React.useState<
    {
      accessType: string;
      securityRoles: string[];
    }[]
  >([]);
  const actionTypeOptions = React.useMemo(() => {
    return data.map(({ accessType }) => accessType);
  }, [data]);
  const securityRoleOptions = React.useMemo(() => {
    const option = data.find(
      (option) => option.accessType === securityRoleForm.values.accessType
    );

    return option ? option.securityRoles : [];
  }, [data, securityRoleForm.values.accessType]);

  React.useEffect(() => {
    setFetching(true);
    getFormGsapAccessTypes()
      .then((data) => {
        setFetching(false);
        setData(data);
      })
      .catch((error) => {
        setFetching(false);
        // [TODO] Handle error
      });
  }, []);

  function onSecurityRoleFormValueChange(
    name: SecurityRoleKeys,
    value: any
  ): void {
    switch (name) {
      case "isUS":
      case "isAP":
      case "isEU":
      case "isVesper":  
        securityRoleForm.set(
          Form.target.VALUES,
          Object.assign(
            {
              isUS: false,
              isAP: false,
              isEU: false,
              isVesper: false,
            },
            {
              [name]: value,
            }
          )
        );
        break;
      case "isAdd":
      case "isRemove":
        securityRoleForm.set(
          Form.target.VALUES,
          Object.assign(
            {
              isAdd: false,
              isRemove: false,
            },
            {
              [name]: value,
            }
          )
        );
        break;
      default:
        securityRoleForm.set(Form.target.VALUE, [name, value]);
    }
    validateSecurityRoleFormValue([name, value]).then(([name, error]) => {
      securityRoleForm.set(Form.target.ERROR, [name, error]);
    });
  }

  function validateSecurityRoleFormValue([name, value]: [
    SecurityRoleKeys,
    any
  ]): Promise<[SecurityRoleKeys, Error?]> {
    switch (name) {
      case "isUS":
      case "isAP":
      case "isEU":
      case "isVesper":   {
        const values = Object.assign(
          {
            isUS: securityRoleForm.values.isUS,
            isAP: securityRoleForm.values.isAP,
            isEU: securityRoleForm.values.isEU,
            isVesper: securityRoleForm.values.isVesper,
          },
          {
            [name]: value,
          }
        );

        if (Object.values(values).every((value) => value === false)) {
          return Promise.resolve(["isUS", Form.Validators.hasValue(undefined)]);
        } else {
          return Promise.resolve(["isUS"]);
        }
      }
      case "isAdd":
      case "isRemove": {
        const values = Object.assign(
          {
            isAdd: securityRoleForm.values.isAdd,
            isRemove: securityRoleForm.values.isRemove,
          },
          {
            [name]: value,
          }
        );

        if (Object.values(values).every((value) => value === false)) {
          return Promise.resolve([
            "isAdd",
            Form.Validators.hasValue(undefined),
          ]);
        } else {
          return Promise.resolve(["isAdd"]);
        }
      }
      case "accessType":
      case "securityRole":
        return Promise.resolve([
          name as SecurityRoleKeys,
          Form.Validators.hasValue(value),
        ]);
      default:
        return Promise.resolve([name as SecurityRoleKeys]);
    }
  }

  function addSecurityRole(): void {
    Promise.all(
      Object.entries(securityRoleForm.values).map(([name, value]) =>
        validateSecurityRoleFormValue([name as SecurityRoleKeys, value])
      )
    ).then((validations) => {
      const valid = validations.reduce((valid, [name, error]) => {
        return valid && !error;
      }, true);

      if (valid) {
        const name = "securityRoles";
        const value = form.values.securityRoles.concat(securityRoleForm.values);

        form.set(Form.target.VALUE, [name, value]);
        validateFormValue([name, value]).then(([name, error]) => {
          form.set(Form.target.ERROR, [name, error]);
        });
        securityRoleForm.reset();
      } else {
        validations.forEach(([name, error]) => {
          securityRoleForm.set(Form.target.ERROR, [name, error]);
        });
      }
    });
  }

  function removeSecurityRole(index: number): void {
    onFormValueChange(
      "securityRoles",
      form.values.securityRoles.filter((securityRole, i) => i !== index)
    );
  }

  function onFormValueChange(name: Key, value: any): void {
    switch (name) {
      case "setup1":
      case "setup2":
      case "setup3":
      case "setup4":
        form.set(Form.target.VALUES, {
          setup1: false,
          setup2: false,
          setup3: false,
          setup4: false,
          [name]: value,
        });
        break;
      // case "accessType1":
      // case "accessType2":
      // case "accessType3":
      // case "accessType4":
      //   form.set(Form.target.VALUES, {
      //     accessType1: false,
      //     accessType2: false,
      //     accessType3: false,
      //     accessType4: false,
      //     [name]: value,
      //   });
      //   break;
      default:
        form.set(Form.target.VALUE, [name, value]);
    }
    validateFormValue([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  function validateFormValue([name, value]: [Key, any]): Promise<
    [Key, Error?]
  > {
    switch (name) {
      case "setup1":
      case "setup2":
      case "setup3":
      case "setup4": {
        const values = Object.assign(
          {
            setup1: form.values.setup1,
            setup2: form.values.setup2,
            setup3: form.values.setup3,
            setup4: form.values.setup4,
          },
          {
            [name]: value,
          }
        );

        if (Object.values(values).every((value) => value === false)) {
          return Promise.resolve([
            "setup1",
            Form.Validators.hasValue(undefined),
          ]);
        } else {
          return Promise.resolve(["setup1"]);
        }
      }
      case "accessType1":
      case "accessType2":
      case "accessType3":
      case "accessType4": {
        const values = Object.assign(
          {
            accessType1: form.values.accessType1,
            accessType2: form.values.accessType2,
            accessType3: form.values.accessType3,
            accessType4: form.values.accessType4,
          },
          {
            [name]: value,
          }
        );

        if (Object.values(values).every((value) => value === false)) {
          return Promise.resolve([
            "accessType1",
            Form.Validators.hasValue(undefined),
          ]);
        } else {
          return Promise.resolve(["accessType1"]);
        }
      }
      case "requestor":
      case "requestorTitle":
      case "requestorTelephoneNumber":
      case "employeeNumber":      
      case "userName":
      case "telephoneNumber":
      case "userDepartment":
      case "userADID":
      case "accessPurpose":
      case "emailAddress":
      case "securityRoles":
        return Promise.resolve([name as Key, Form.Validators.hasValue(value)]);
      case "lengthOfContract": 
        return Promise.resolve([name as Key, Form.Validators.hasValue(value) || Form.Validators.isNumber(value)]); 
      default:
        return Promise.resolve([name as Key]);
    }
  }

  function onFormSubmit(): void {
    Promise.all(
      Object.entries(form.values).map(([name, value]) =>
        validateFormValue([name as Key, value])
      )
    ).then((validations) => {
      const valid = validations.reduce((valid, [name, error]) => {
        return valid && !error;
      }, true);

      if (valid) {
        onSubmit(form.values);
      } else {
        validations.forEach(([name, error]) => {
          form.set(Form.target.ERROR, [name, error]);
        });
      }
    });
  }

  

  return (
    <Wrapper
      onSubmit={onFormSubmit}
      onCancel={() => {
        onCancel();
        if (values) {
          form.set(Form.target.VALUES, values);
        } else {
          form.reset();
        }
      }}
      open={open}
      title="G2 Platform Internal Access Form"
      size="md"
      readonly={readonly}
    >
      <Form>
        <Form.Title>Application Contact Detail</Form.Title>
        <Form.Textbox
          name="requestor"
          label="Requestor Name"
          error={form.errors.requestor}
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.requestor}
        />
        <Form.Textbox
          name="requestorTelephoneNumber"
          label="Telephone No."
          error={form.errors.requestorTelephoneNumber}
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.requestorTelephoneNumber}
        />
        <Form.Textbox
          name="requestorTitle"
          label="Requestor Title"
          error={form.errors.requestorTitle}
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.requestorTitle}
        />
        <Form.Datebox
          name="dateRequested"
          label="Request's Effective Date (optional)"
          onChange={onFormValueChange}
          size={6}
          value={form.values.dateRequested}
        />
        <Form.Title>Setup Type</Form.Title>
        <Grid container item xs={12} spacing={2}>
          <Grid container item xs={6}>
            <Form.Textbox
              name="employeeNumber"
              label="Employee No."
              error={form.errors.employeeNumber}
              required
              onChange={onFormValueChange}
              size={12}
              value={form.values.employeeNumber}
            />
            <Form.Textbox
              name="lengthOfContract"
              label="Length of Contract"
              error={form.errors.lengthOfContract}
              required
              onChange={onFormValueChange}
              size={12}
              value={form.values.lengthOfContract}
            />
          </Grid>
          <Grid container item xs={6}>
            <Form.Radiogroup
              name="setup"
              label="Action"
              required
              error={form.errors.setup1}
              size={12}
              options={[
                {
                  label: "Add New Employee",
                  value: "setup1",
                },
                {
                  label: "Add New Contractor/Consultant",
                  value: "setup2",
                },
                {
                  label: "Update Employee",
                  value: "setup3",
                },
                {
                  label: "Delete Employee",
                  value: "setup4",
                },
              ]}
              onChange={(name, value) => {
                onFormValueChange(value as Key, true);
              }}
              value={
                form.values.setup1
                  ? "setup1"
                  : form.values.setup2
                  ? "setup2"
                  : form.values.setup3
                  ? "setup3"
                  : form.values.setup4
                  ? "setup4"
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Form.Title>User Details</Form.Title>
        <Form.Textbox
          name="userName"
          label="Name"
          error={form.errors.userName}
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.userName}
        />
        <Form.Textbox
          name="telephoneNumber"
          label="Telephone No."
          error={form.errors.telephoneNumber}
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.telephoneNumber}
        />
        <Form.Textbox
          name="userDepartment"
          error={form.errors.userDepartment}
          label="Department"
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.userDepartment}
        />
        <Form.Textbox
          name="userADID"
          error={form.errors.userADID}
          label="User's Active Directory ID"
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.userADID}
        />
        <Form.Textbox
          name="accessPurpose"
          error={form.errors.accessPurpose}
          label="Access Purpose"
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.accessPurpose}
        />
        <Form.Datebox
          name="accessEffectiveDate"
          label="Access Effective Date"
          onChange={onFormValueChange}
          size={6}
          value={form.values.accessEffectiveDate}
        />
        <Form.Textbox
          name="emailAddress"
          error={form.errors.emailAddress}
          label="Email Address"
          onChange={onFormValueChange}
          required
          size={6}
          value={form.values.emailAddress}
        />
        <Form.Datebox
          name="accessEndDate"
          label="Access End Date"
          onChange={onFormValueChange}
          size={6}
          value={form.values.accessEndDate}
        />
        <Grid container item xs={12}>
          <Grid container item xs={6}>
            <Form.Group label="Environment - Certification">
              <Form.Checkbox
                name="envCertUS"
                label="US"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envCertUS}
              />
              <Form.Checkbox
                name="envCertAP"
                label="AP"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envCertAP}
              />
              <Form.Checkbox
                name="envCertEU"
                label="EU"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envCertEU}
              />  
              <Form.Checkbox
                name="envCertVesper"
                label="NAC/VESPER"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envCertVesper}
              />  
            </Form.Group>
          </Grid>
          <Grid container item xs={6}>
            <Form.Group label="Environment - Production">
              <Form.Checkbox
                name="envProdUS"
                label="US"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envProdUS}
              />
              <Form.Checkbox
                name="envProdAP"
                label="AP"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envProdAP}
              />
              <Form.Checkbox
                name="envProdEU"
                label="EU"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envProdEU}
              />  
              <Form.Checkbox
                name="envProdVesper"
                label="NAC/VESPER"
                onChange={onFormValueChange}
                size={6}
                value={form.values.envProdVesper}
              />  
            </Form.Group>
          </Grid>
        </Grid>
        <Form.Title error={form.errors.accessType1}>
          Requesting Access To:
        </Form.Title>
        <Form.Checkbox
          name="accessType1"
          label="CMF"
          onChange={onFormValueChange}
          size={2}
          value={form.values.accessType1}
        />
        <Form.Checkbox
          name="accessType2"
          label="TDS"
          onChange={onFormValueChange}
          size={2}
          value={form.values.accessType2}
        />
        <Form.Checkbox
          name="accessType3"
          label="G2"
          onChange={onFormValueChange}
          size={2}
          value={form.values.accessType3}
        />
        <Form.Checkbox
          name="accessType4"
          label="USAT (Requires Approval)"
          onChange={onFormValueChange}
          size={2}
          value={form.values.accessType4}
        />
        <Form.Title>Card Masking</Form.Title>
        <Form.Radiogroup
          name="cardMask"
          onChange={onFormValueChange}
          options={[
            {
              value: "Full Hide",
              label: "Full Hide",
            },
            {
              value: "Full View",
              label: "Full View *",
            },
            {
              value: "Export Only Hide",
              label: "Export Only Hide *",
            },
          ]}
          row
          size={12}
          value={form.values.cardMask}
        />
        <Form.Text color="#EC9A2F">* Requires Additional Approval</Form.Text>
        <Form.Title>Max Records per TDS Report (Default 2000)</Form.Title>
        <Form.Radiogroup
          name="maxRecord"
          onChange={onFormValueChange}
          options={[
            {
              value: "1000",
              label: "1000",
            },
            {
              value: "2000",
              label: "2000",
            },
            {
              value: "3000",
              label: "3000",
            },
            {
              value: "4000",
              label: "4000",
            },
            {
              value: "5000",
              label: "5000",
            },
            {
              value: "6000",
              label: "6000",
            },
            {
              value: "7000",
              label: "7000",
            },
            {
              value: "8000",
              label: "8000",
            },
            {
              value: "9000",
              label: "9000",
            },
            {
              value: "10000",
              label: "10000",
            },
          ]}
          row
          size={12}
          value={form.values.maxRecord}
        />
        <Form.Title info="Enter customer Number(s) or Select Lines of Business below">
          Requested Access
        </Form.Title>
        <Form.Textbox
          name="contactHeirarchy"
          label="Customer Number(s): Will include all descending hierarchy"
          onChange={onFormValueChange}
          size={6}
          value={form.values.contactHeirarchy}
        />
        <Form.Text>
          Select one or more Lines of Business from the List below:
        </Form.Text>
        <Form.Group>
          <Form.Checkbox
            name="ap1"
            label="Asia Pacific Direct"
            onChange={onFormValueChange}
            size={3}
            value={form.values.ap1}
          />
          <Form.Checkbox
            name="cad2"
            label="Canada Direct ESA"
            onChange={onFormValueChange}
            size={3}
            value={form.values.cad2}
          />
          <Form.Checkbox
            name="us1"
            label="United States Direct"
            onChange={onFormValueChange}
            size={3}
            value={form.values.us1}
          />
          <Form.Checkbox
            name="us3"
            label="United States Indirect"
            onChange={onFormValueChange}
            size={3}
            value={form.values.us3}
          />
          <Form.Checkbox
            name="ap2"
            label="Asia Pacific Indirect"
            onChange={onFormValueChange}
            size={3}
            value={form.values.ap2}
          />
          <Form.Checkbox
            name="cad3"
            label="Canada Indirect"
            onChange={onFormValueChange}
            size={3}
            value={form.values.cad3}
          />
          <Form.Checkbox
            name="us2"
            label="United States Direct ISO"
            onChange={onFormValueChange}
            size={3}
            value={form.values.us2}
          />
          <Form.Checkbox
            name="us4"
            label="United States Indirect ISO"
            onChange={onFormValueChange}
            size={3}
            value={form.values.us4}
          />
          <Form.Checkbox
            name="cad1"
            label="Canada Direct"
            onChange={onFormValueChange}
            size={3}
            value={form.values.cad1}
          />
          <Form.Checkbox
            name="latinAmerica"
            label="Latin America & Caribbean"
            onChange={onFormValueChange}
            size={3}
            value={form.values.latinAmerica}
          />
          <Form.Checkbox
            name="euacquiring"
            label="Europe International Acquiring"
            onChange={onFormValueChange}
            size={3}
            value={form.values.euacquiring}
          />
          <Form.Checkbox
            name="eudirect"
            label="Europe UK Direct"
            onChange={onFormValueChange}
            size={3}
            value={form.values.eudirect}
          />
        </Form.Group>

        <Form.Title
          error={form.errors.securityRoles}
          subtitle="Select the security role to which you are requesting access"
        >
          Security Role
        </Form.Title>
        <Grid item xs={12}>
          <Box border={1} borderColor="grey.500">
            <Box p={2} bgcolor="#8A92A5" color="white">
              <Typography variant="subtitle2" color="inherit">
                1- Access Type
              </Typography>
            </Box>
            <Box p={2}>
              <Grid container spacing={2}>
                <Form.Dropdown
                  name="accessType"
                  error={securityRoleForm.errors.accessType}
                  onChange={onSecurityRoleFormValueChange}
                  options={actionTypeOptions}
                  size={6}
                  value={securityRoleForm.values.accessType}
                  required
                  loading={fetching}
                />
                <Grid container item xs={6} alignItems="center">
                  <Form.Error error={securityRoleForm.errors.accessType} />
                </Grid>
              </Grid>
            </Box>
            <Box p={2} bgcolor="#8A92A5" color="white">
              <Typography variant="subtitle2" color="inherit">
                2- Security Role
              </Typography>
            </Box>
            <Box p={2}>
              <Grid container spacing={2}>
                <Form.Dropdown
                  name="securityRole"
                  error={securityRoleForm.errors.securityRole}
                  disabled={!securityRoleOptions.length}
                  onChange={onSecurityRoleFormValueChange}
                  options={securityRoleOptions}
                  size={6}
                  value={securityRoleForm.values.securityRole}
                  required
                  loading={fetching}
                />
                <Grid container item xs={6} alignItems="center">
                  <Form.Error error={securityRoleForm.errors.securityRole} />
                </Grid>
                <Form.Group label="Instance">
                  <Form.Radiobutton
                    name="isUS"
                    label="US"
                    onChange={onSecurityRoleFormValueChange}
                    size={2}
                    value={securityRoleForm.values.isUS}
                  />
                  <Form.Radiobutton
                    name="isAP"
                    label="AP"
                    onChange={onSecurityRoleFormValueChange}
                    size={2}
                    value={securityRoleForm.values.isAP}
                  />
                  <Form.Radiobutton
                    name="isEU"
                    label="EU"
                    onChange={onSecurityRoleFormValueChange}
                    size={2}
                    value={securityRoleForm.values.isEU}
                  />
                  <Form.Radiobutton
                    name="isVesper"
                    label="NAC/VESPER"
                    onChange={onSecurityRoleFormValueChange}
                    size={2}
                    value={securityRoleForm.values.isVesper}
                  />
                  <Form.Error error={securityRoleForm.errors.isUS} />
                </Form.Group>
              </Grid>
            </Box>
            <Box p={2} bgcolor="#8A92A5" color="white">
              <Typography variant="subtitle2" color="inherit">
                3- Action
              </Typography>
            </Box>
            <Box p={2}>
              <Grid container spacing={2}>
                <Form.Radiobutton
                  name="isAdd"
                  label="Add"
                  onChange={onSecurityRoleFormValueChange}
                  size={2}
                  value={securityRoleForm.values.isAdd}
                />
                <Form.Radiobutton
                  name="isRemove"
                  label="Remove"
                  onChange={onSecurityRoleFormValueChange}
                  size={2}
                  value={securityRoleForm.values.isRemove}
                />
                <Form.Error error={securityRoleForm.errors.isAdd} />
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Button variant="outlined" onClick={addSecurityRole}>
            + Add
          </Button>
        </Grid>
        {form.values.securityRoles.length ? (
          <React.Fragment>
            <Grid item xs={12}>
              <Typography variant="subtitle2">List</Typography>
            </Grid>
            <Grid item xs={12}>
              <Table
                columns={[
                  { label: "Access Type" },
                  { label: "Security Role" },
                  { label: "Instance" },
                  { label: "Action" },
                  { label: "" },
                ]}
                rowHeight={43}
              >
                {form.values.securityRoles.map((role, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{role.accessType}</Table.Cell>
                    <Table.Cell>{role.securityRole}</Table.Cell>
                    <Table.Cell>{role.isAP ? "AP" : (role.isUS) ? "US" : (role.isEU ? "EU" : "NAC/VESPER")}</Table.Cell>
                    <Table.Cell>{role.isAdd ? "Add" : "Remove"}</Table.Cell>
                    <Table.Cell>
                      <IconButton
                        size="small"
                        onClick={() => removeSecurityRole(index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table>
            </Grid>
          </React.Fragment>
        ) : null}
      </Form>
    </Wrapper>
  );
};
